import { useNavigate } from "react-router-dom";

export const useHandleSmartNavigation = () => {
  const navigate = useNavigate();

  const handleSmartNavigation = (e, path) => {
    if (!path) return;
    if (e.button !== 0) return; // Ignore right or middle clicks

    if (e.ctrlKey || e.metaKey) {
      window.open(path, "_blank", "noopener,noreferrer");
    } else {
      navigate(path);
    }
  };

  return handleSmartNavigation;
};